import React, { useState, useEffect } from 'react';
import './DuplicataBulletins.css';
import DashboardHeader from '../../components/DashboardHeader';
import AdminNavigationBar from '../../components/AdminNavigationBar';
import { DownloadIcon, SearchIcon } from '../../components/Icons';

function DuplicataBulletins() {
  const [bulletins, setBulletins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtres, setFiltres] = useState({
    classe: '',
    trimestre: '',
    annee_scolaire: '2025-2026',
    recherche: ''
  });

  useEffect(() => {
    chargerBulletins();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtres.classe, filtres.trimestre, filtres.annee_scolaire]);

  const chargerBulletins = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      
      if (filtres.classe) params.append('classe', filtres.classe);
      if (filtres.trimestre) params.append('trimestre', filtres.trimestre);
      if (filtres.annee_scolaire) params.append('annee_scolaire', filtres.annee_scolaire);

      const response = await fetch(`http://127.0.0.1:8000/api/v1/admin/bulletins/duplicata?${params}`);
      const data = await response.json();
      
      if (response.ok && data.success) {
        setBulletins(data.data || []);
      } else {
        console.error('Erreur API:', data);
        setBulletins([]);
      }
    } catch (error) {
      console.error('Erreur chargement bulletins:', error);
      setBulletins([]);
    } finally {
      setLoading(false);
    }
  };

  const telechargerBulletin = async (bulletinId, nomComplet) => {
    try {
      const response = await fetch(`http://127.0.0.1:8000/api/v1/admin/bulletins/${bulletinId}/telecharger`);
      
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `bulletin_${nomComplet.replace(/ /g, '_')}.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } else {
        alert('Erreur lors du téléchargement du bulletin');
      }
    } catch (error) {
      console.error('Erreur téléchargement:', error);
      alert('Erreur de connexion lors du téléchargement');
    }
  };

  const bulletinsFiltres = bulletins.filter(bulletin => {
    if (!filtres.recherche) return true;
    const recherche = filtres.recherche.toLowerCase();
    return (
      bulletin.etudiant.nom_complet.toLowerCase().includes(recherche) ||
      bulletin.etudiant.matricule.toLowerCase().includes(recherche) ||
      bulletin.etudiant.classe.toLowerCase().includes(recherche)
    );
  });

  const getStatutBadge = (statut) => {
    const badges = {
      'genere': { label: 'Généré', class: 'badge-success' },
      'publie': { label: 'Publié', class: 'badge-info' },
      'telecharge': { label: 'Téléchargé', class: 'badge-primary' }
    };
    const badge = badges[statut] || { label: statut, class: 'badge-secondary' };
    return <span className={`badge ${badge.class}`}>{badge.label}</span>;
  };

  const getMoyenneClass = (moyenne) => {
    if (moyenne >= 16) return 'excellent';
    if (moyenne >= 14) return 'tres-bien';
    if (moyenne >= 12) return 'bien';
    if (moyenne >= 10) return 'assez-bien';
    return 'insuffisant';
  };

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <AdminNavigationBar 
        title="Duplicata des Bulletins" 
        onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
      />
      <div className="admin-container">
        <main className="admin-content admin-content-full">
          <div className="duplicata-container">
            
            {/* En-tête */}
            <div className="page-header">
              <div className="header-content">
                <div className="header-text">
                  <h1>📋 Duplicata des Bulletins</h1>
                  <p>Consultez et téléchargez tous les bulletins générés</p>
                </div>
                <div className="header-stats">
                  <div className="stat-item">
                    <span className="stat-number">{bulletins.length}</span>
                    <span className="stat-label">Bulletins</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Filtres */}
            <div className="filters-card">
              <div className="card-header">
                <h3>🔍 Filtres</h3>
              </div>
              <div className="filters-grid">
                <div className="filter-group">
                  <label>📚 Classe</label>
                  <select 
                    value={filtres.classe} 
                    onChange={(e) => setFiltres({...filtres, classe: e.target.value})}
                  >
                    <option value="">Toutes les classes</option>
                    <option value="6ème">6ème</option>
                    <option value="5ème">5ème</option>
                    <option value="4ème">4ème</option>
                    <option value="3ème">3ème</option>
                    <option value="Seconde A">Seconde A</option>
                    <option value="Première">Première</option>
                    <option value="Terminale">Terminale</option>
                  </select>
                </div>

                <div className="filter-group">
                  <label>📅 Trimestre</label>
                  <select 
                    value={filtres.trimestre} 
                    onChange={(e) => setFiltres({...filtres, trimestre: e.target.value})}
                  >
                    <option value="">Tous les trimestres</option>
                    <option value="1">Trimestre 1</option>
                    <option value="2">Trimestre 2</option>
                    <option value="3">Trimestre 3</option>
                  </select>
                </div>

                <div className="filter-group">
                  <label>📊 Année scolaire</label>
                  <select 
                    value={filtres.annee_scolaire} 
                    onChange={(e) => setFiltres({...filtres, annee_scolaire: e.target.value})}
                  >
                    <option value="2025-2026">2025-2026</option>
                    <option value="2024-2025">2024-2025</option>
                  </select>
                </div>

                <div className="filter-group">
                  <label><SearchIcon size={16} /> Rechercher</label>
                  <input 
                    type="text"
                    placeholder="Nom, matricule, classe..."
                    value={filtres.recherche}
                    onChange={(e) => setFiltres({...filtres, recherche: e.target.value})}
                  />
                </div>
              </div>
            </div>

            {/* Liste des bulletins */}
            <div className="bulletins-card">
              {loading ? (
                <div className="loading-state">
                  <div className="spinner"></div>
                  <h4>Chargement des bulletins...</h4>
                </div>
              ) : bulletinsFiltres.length === 0 ? (
                <div className="empty-state">
                  <div className="empty-icon">📄</div>
                  <h3>Aucun bulletin trouvé</h3>
                  <p>Aucun bulletin ne correspond à vos critères de recherche</p>
                </div>
              ) : (
                <div className="bulletins-table-container">
                  <table className="bulletins-table">
                    <thead>
                      <tr>
                        <th>Matricule</th>
                        <th>Élève</th>
                        <th>Classe</th>
                        <th>Trimestre</th>
                        <th>Année</th>
                        <th>Moyenne</th>
                        <th>Rang</th>
                        <th>Absences</th>
                        <th>Retards</th>
                        <th>Statut</th>
                        <th>Date</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bulletinsFiltres.map((bulletin) => (
                        <tr key={bulletin.id}>
                          <td className="matricule">{bulletin.etudiant.matricule}</td>
                          <td className="nom-eleve">{bulletin.etudiant.nom_complet}</td>
                          <td>{bulletin.etudiant.classe}</td>
                          <td className="trimestre">T{bulletin.trimestre}</td>
                          <td>{bulletin.annee_scolaire}</td>
                          <td>
                            <span className={`moyenne ${getMoyenneClass(bulletin.moyenne_generale)}`}>
                              {bulletin.moyenne_generale}/20
                            </span>
                          </td>
                          <td className="rang">{bulletin.rang}</td>
                          <td className="absences">{bulletin.total_absences}</td>
                          <td className="retards">{bulletin.total_retards}</td>
                          <td>{getStatutBadge(bulletin.statut)}</td>
                          <td className="date">
                            {new Date(bulletin.date_generation).toLocaleDateString('fr-FR')}
                          </td>
                          <td>
                            <button 
                              className="btn-download"
                              onClick={() => telechargerBulletin(bulletin.id, bulletin.etudiant.nom_complet)}
                              title="Télécharger le bulletin"
                            >
                              <DownloadIcon size={18} />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

          </div>
        </main>
      </div>
    </div>
  );
}

export default DuplicataBulletins;
